import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPaperPlaneTiltIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 256 256",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M227.32 28.68a16 16 0 0 0-15.66-4.08l-.15.05L19.57 82.84a16 16 0 0 0-2.42 29.84l85.62 40.55 40.55 85.62A15.86 15.86 0 0 0 157.74 248q.69 0 1.38-.06a15.88 15.88 0 0 0 14-11.51l58.2-191.94v-.15A16 16 0 0 0 227.32 28.68ZM157.83 231.85l-.05.14L118.42 148.9l47.24-47.25a8 8 0 0 0-11.31-11.31L107.1 137.58 24 98.22l.14-.05L216 40Z",
		fill: "currentColor"
	})
});
export default SvgPaperPlaneTiltIcon;
